import React, { useState, useEffect } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { useNavigate } from 'react-router-dom';
import MainNavigation from '../../components/ui/MainNavigation';
import Button from '../../components/ui/Button';
import ProductList from './components/ProductList';
import ProductForm from './components/ProductForm';
import ProductMetrics from './components/ProductMetrics';

const ProviderProductManagement = () => {
  const { user, userProfile, loading } = useAuth();
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState('active');
  const [showForm, setShowForm] = useState(false);
  const [editingProduct, setEditingProduct] = useState(null);

  useEffect(() => {
    if (!loading && (!user || !['provider', 'superadmin']?.includes(userProfile?.user_type))) {
      navigate('/leverancier-login');
    }
  }, [user, userProfile, loading, navigate]);

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-background">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary mx-auto mb-4"></div>
          <p className="text-muted-foreground">Laden...</p>
        </div>
      </div>
    );
  }

  const handleEdit = (product) => {
    setEditingProduct(product);
    setShowForm(true);
  };

  const handleFormClose = () => {
    setShowForm(false);
    setEditingProduct(null);
  };

  const tabs = [
    { id: 'active', label: 'Actieve Producten', icon: 'Package' },
    { id: 'draft', label: 'Concepten', icon: 'FileEdit' },
    { id: 'archived', label: 'Gearchiveerd', icon: 'Archive' },
  ];

  return (
    <div className="min-h-screen bg-background">
      <MainNavigation />

      <main className="pt-16 lg:pt-0 lg:ml-[72px] transition-all duration-300">
        {/* Header */}
        <div className="bg-card border-b border-border shadow-elevation-1 p-4 sm:p-6">
          <div className="flex items-center justify-between">
            <div>
              <h1 className="text-2xl font-heading font-bold text-foreground">Productbeheer</h1>
              <p className="text-sm text-muted-foreground mt-1">
                Beheer uw productcatalogus en presenteer uw diensten
              </p>
            </div>
            <Button
              onClick={() => setShowForm(true)}
              iconName="Plus"
              iconPosition="left"
            >
              Nieuw Product
            </Button>
          </div>
        </div>

        {/* Content */}
        <div className="p-6 space-y-6">
          {/* Metrics */}
          <ProductMetrics />

          {/* Tabs */}
          <div className="bg-card border border-border rounded-lg overflow-hidden">
            <div className="border-b border-border">
              <div className="flex space-x-1 p-2">
                {tabs?.map((tab) => (
                  <button
                    key={tab?.id}
                    onClick={() => setActiveTab(tab?.id)}
                    className={`flex items-center space-x-2 px-4 py-2 rounded-md text-sm font-medium transition-colors ${
                      activeTab === tab?.id
                        ? 'bg-primary text-primary-foreground'
                        : 'text-muted-foreground hover:bg-muted hover:text-foreground'
                    }`}
                  >
                    <span>{tab?.label}</span>
                  </button>
                ))}
              </div>
            </div>

            {/* Product List */}
            <div className="p-6">
              <ProductList
                status={activeTab}
                onEdit={handleEdit}
              />
            </div>
          </div>
        </div>
      </main>

      {/* Product Form Modal */}
      {showForm && (
        <ProductForm
          product={editingProduct}
          onClose={handleFormClose}
        />
      )}
    </div>
  );
};

export default ProviderProductManagement;